import { clientMount } from '@vp/ubik-fragment-react';
import { Fragment } from '../fragments/business-name-generator';
import type { MountWithRootOptions } from '@vp/ubik-fragment-types';
import type { Props } from '../fragments/business-name-generator';

export const mount: MountWithRootOptions<Props> = async (rootElement, renderProps, rootOptions) => {
    return clientMount(<Fragment {...renderProps} />, rootElement, rootOptions);
};
